import '../App.css';

function Copyright() {
    return (
        <footer className="copyright" 
        style={{ 
            fontWeight: "bold" 
            
            }}>
            CampusEdu Learning LLC. All rights reserved.
        </footer>
    );
}

export default Copyright;
